import vue from "vue";
import ApiService from "@/common/ApiService";
const apiService = new ApiService(vue.prototype.$config.fastTrackBaseAddress);

export default ({
  state: {
    selectedReserve: {},
    customerInfo: {},
    bookingData: {},
    guests: []
  },

  mutations: {
    SetSelectedReserve(state, item) {
      state.selectedReserve = item;
    },
    SetCustomerInfo(state, item) {
      state.customerInfo = item;
    },
    SetGuestsInfo(state, item) {
      state.guests = item;
    },
    SetBookingData(state, item) {
      state.bookingData = item;
    },
  },

  getters: {
    GetSelectedReserve(state) {
      return state.selectedReserve;
    },
    GetCustomerInfo(state) {
      return state.customerInfo;
    },
    GetGuestsInfo(state) {
      return state.guests;
    },
    GetBookingData(state) {
      return state.bookingData;
    },
  },

  actions: {

    async getProductServices(context, providerId) {
      try {
        const response = await apiService.Get("/product/GetProducts?providerId=" + providerId)

        return response.data;
      } catch (error) {
        console.log(error);
      }
    },


    async checkAvailability(context, data) {
      try {
        const response = await apiService.Post("/Availability/CheckAvailability", data);
        return response;

      } catch (err) {
        console.log(err);
      }

    },

    async getIPGs(context, data) {
      try {
        const response = await apiService.Post("/IPG/GetIPGs", data);
        return response.data;

      } catch (err) {
        console.log(err);
      }

    },
    async depositBooking(context, data) {
      try {
        const response = await apiService.Post("/Booking/DepositBooking", data);

        return response.data;

      } catch (err) {
        console.log(err);
      }

    },
    async tourismBooking(context, data) {
      try {
        const response = await apiService.Post("/Booking/payment", data);

        return response.data.data;

      } catch (err) {
        console.log(err);
      }
    },
    async confirmBookingV2 (context, data) {
      try {
        const response = await apiService.Post("/Booking/confirmBookingV2", data);
  
        return response;

      } catch (err) {
        console.log(err);
      }
    },
    async getBookingDetail(context, data) {
      try {
        const response = await apiService.Post("/Booking/getbyIdNew" , data);

        return response.data;

      } catch (err) {
        console.log(err);
      }
    },
    async getByVoucher(context, data) {
      try {
        const response = await apiService.Post("/Booking/getByVoucherNew" , data);

        return response.data;

      } catch (err) {
        console.log(err);
      }
    },

    ///cancel reservation

    async getCancelreason(context) {
      try {
        const response = await apiService.Get("/cancelreason/get");

        return response;

      } catch (err) {
        console.log(err);
      }
    },


    async getBookingListForCancel(context, data) {
      try {
        const response = await apiService.Post("/Booking/getBookingListForCancel", data);

        return response;

      } catch (err) {
        console.log(err);
      }
    },

    async bookingCancel(context, data) {
      try {
        const response = await apiService.Post("/booking/Cancel", data);

        return response;

      } catch (err) {
        console.log(err);
      }
    },

    async getBookingItemForEdit(context, data) {
      try {
        const response = await apiService.Post("/booking/getBookingItemForEdit", data);

        return response.data;

      } catch (err) {
        console.log(err);
      }
    },

    async editFastTrackInfo(context, data) {
      try {
        const response = await apiService.Post("/Booking/edit", data);

        return response.data;

      } catch (err) {
        console.log(err);
      }
    },
    async increaseDeposit(context, data) {
      try {
        const response = await apiService.Post("/Source/IncreaseDeposit", data);

        return response;

      } catch (err) {
        console.log(err);
      }
    },

    storeSelectedReserve(context, data) {
      context.commit("SetSelectedReserve", data);
    },

    storeCustomerInfo(context, data) {
      context.commit("SetCustomerInfo", data);
    },
    storeGuestsInfo(context, data) {
      context.commit("SetGuestsInfo", data);
    },
    storeBookingData(context, data) {
      context.commit("SetBookingData", data);
    },
  }

});